var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bot"},[_c('div',[_vm._v("Address/地址：浙江省湖州市德清县雷甸镇工业区")]),_c('div',[_vm._v("Tel/联系电话：13105719688")]),_c('div',[_vm._v("Mail/邮箱：wwwjy8811@126.com")]),_c('div',[_vm._v("浙ICP备2024099564号-1")])])
}]

export { render, staticRenderFns }